import {Clock, TrendingUp, Users} from 'lucide-react';

const monthlyData = [
    {month: 'فروردین', performance: 75, attendance: 85, hours: 120},
    {month: 'اردیبهشت', performance: 78, attendance: 88, hours: 135},
    {month: 'خرداد', performance: 82, attendance: 90, hours: 145},
    {month: 'تیر', performance: 85, attendance: 92, hours: 150},
    {month: 'مرداد', performance: 87, attendance: 93, hours: 155},
];

export default function PerformanceChart() {
    const maxValue = 160;

    return (
        <div className=" rounded-xl shadow-sm border dark:border-gray-600 border-gray-100 p-6">
            <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-4 text-xs">
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 bg-blue-500 rounded"></div>
                        <span className=" ">عملکرد دانشجویان</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 bg-green-500 rounded"></div>
                        <span className=" ">نرخ حضور</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 bg-purple-500 rounded"></div>
                        <span className=" ">ساعات فعالیت</span>
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    <TrendingUp className="w-5 h-5  "/>
                    <h2 className="text-lg font-bold  ">تحلیل عملکرد</h2>
                </div>
            </div>

            <div className="relative h-64">
                <div className="absolute inset-0 flex items-end justify-between gap-4 px-4">
                    {monthlyData.map((data, index) => {
                        const performanceHeight = (data.performance / maxValue) * 100;
                        const attendanceHeight = (data.attendance / maxValue) * 100;
                        const hoursHeight = (data.hours / maxValue) * 100;

                        return (
                            <div key={index} className="flex-1 flex flex-col items-center">
                                <div className="w-full flex gap-1 items-end h-48">
                                    <div className="flex-1 relative group">
                                        <div
                                            className="bg-gradient-to-t from-blue-500 to-blue-400 rounded-t transition-all duration-300 hover:from-blue-600 hover:to-blue-500 cursor-pointer"
                                            style={{height: `${performanceHeight}%`}}
                                        >
                                            <div
                                                className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                                                {data.performance}%
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-1 relative group">
                                        <div
                                            className="bg-gradient-to-t from-green-500 to-green-400 rounded-t transition-all duration-300 hover:from-green-600 hover:to-green-500 cursor-pointer"
                                            style={{height: `${attendanceHeight}%`}}
                                        >
                                            <div
                                                className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                                                {data.attendance}%
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-1 relative group">
                                        <div
                                            className="bg-gradient-to-t from-purple-500 to-purple-400 rounded-t transition-all duration-300 hover:from-purple-600 hover:to-purple-500 cursor-pointer"
                                            style={{height: `${hoursHeight}%`}}
                                        >
                                            <div
                                                className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                                                {data.hours}h
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-2 text-xs   font-medium">{data.month}</div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="grid grid-cols-3 gap-4 mt-6 pt-6 border-t border-gray-100">
                <div className="text-center">
                    <div className="flex items-center justify-center gap-2 mb-2">
                        <TrendingUp className="w-5 h-5 text-blue-500"/>
                    </div>
                    <p className="text-2xl font-bold  ">87%</p>
                    <p className="text-xs  ">میانگین عملکرد</p>
                </div>
                <div className="text-center">
                    <div className="flex items-center justify-center gap-2 mb-2">
                        <Users className="w-5 h-5 text-green-500"/>
                    </div>
                    <p className="text-2xl font-bold  ">93%</p>
                    <p className="text-xs  ">نرخ حضور</p>
                </div>
                <div className="text-center">
                    <div className="flex items-center justify-center gap-2 mb-2">
                        <Clock className="w-5 h-5 text-purple-500"/>
                    </div>
                    <p className="text-2xl font-bold  ">155</p>
                    <p className="text-xs  ">ساعات این ماه</p>
                </div>
            </div>
        </div>
    );
}
